import axios from 'axios'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

export const useErrorHandler = (): { handle: (error: Error | unknown) => void } => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const handleError = (error: Error | unknown): void => {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Whatever the snackbar ends up saying, what the server answered has to
        // survive: without this the reason is lost and a support case begins
        // with a console of one word.
        console.error(
          `${error.config?.method?.toUpperCase()} ${error.config?.url} → ${error.response.status}`,
          error.response.data
        )

        if (error.response.status === 401) {
          enqueueSnackbar(t('error.sessionExpired'), { variant: 'error' })
        } else {
          // The reasons we have words for are translated; the rest are shown as
          // the server wrote them. They read as English sentences, which is far
          // better than the translation key the user used to be given.
          const reason = error?.response?.data?.error?.message

          enqueueSnackbar(t(`backend.${reason}`, { defaultValue: reason }), { variant: 'error' })
        }
      } else {
        if (process.env.NODE_ENV === 'development') console.error(error)
        if (error instanceof Error) enqueueSnackbar(t(error.message), { variant: 'error' })
      }
    }
  }

  return { handle: handleError } as const
}
